export default "__VITE_ASSET__BjTmKpEh__"